<template>
    <div class="pro_box" v-cloak>
        <div class="top_img">
            <img src="../../../assets/icons/官网首页_slices/details_hr.png" alt="">
            <div class="top_font">
                <div class="font_title">HR数字化转型</div>
                <div class="font_deputy">HR digital</div>
            </div>
        </div>
        <div class="tbs_box"> 
            <div 
                class="tab_item" 
                :class="active==item.id?'cactive':''"
                @click="tabswitch(item)"
                v-for="(item,index) of tab" :key="index">
                {{ item.title }}
            </div>
        </div>
        <div class="content_one_box" v-if="active==1">
            <div class="child_content">
                <div class="item_box" v-for="(item,index) of humanlist" :key="index">
                    <img class="img_box" :src="item.resource" alt="">
                    <div class="font_box">
                        <div class="font_title">{{ item.title }}</div>
                        <div  class="html_box" v-html="item.content"></div>
                    </div>
                </div>
            </div>
        </div>
        <bottomnav :display="true"></bottomnav>
    </div>
</template>
<script>
import bottomnav from './bottomnav.vue';
export default{
    components:{
        bottomnav
    },
    data(){
        return{
            textarea:null,
            active:null,
            tab:[
                {id:1,title:'HR数字化转型'},
            ],
            humanlist:[],
          
            text:null,
        }
    },
    created(){
        
        if(this.$route.query.type){
            this.active=Number(this.$route.query.type)
        }else{
            this.active=this.tab[0].id;
        }
        this.axioslist()
    },
    methods:{
        axioslist(){
            this.$webhttp.get('v1/web/number').then((res)=>{
                if(res.code==200){
                    res.data.forEach((item,index,array)=>{
                        item.content=item.content.replace(/\n/g,'<br/>')        
                    })
                    this.humanlist=res.data
                }else{  
                    this.$message.error(res.message)
                }
            })
        },
        tabswitch(item){
            this.active=item.id
        }
    },
}
</script>
<style lang="less" scoped>
    .pro_box{
        width: 100%;
        box-sizing: border-box;
        .top_img{
            width: 100%;
            height: 250px;
            position: relative;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .top_font{
                position: absolute;
                left: 50%;
                top: 50%;
                color: #FFFFFF;
                text-align: center;
                transform: translateX(-50%) translateY(-50%);
                .font_title{
                    font-weight: bold;
                    font-size: 38px;
                    color: #FFFFFF;
                    line-height: 60px;
                    text-shadow: 0px 4px 10px rgba(0,0,0,0.1);
                }
                .font_deputy{
                    font-weight: 400;
                    font-size: 36px;
                    color: #FFFFFF;
                    text-shadow: 0px 4px 10px rgba(0,0,0,0.1);
                }
            }
        }
        .content_two_box{
            height: 100%;
            width: 80%;
            box-sizing: border-box;
            border-right: 1px solid brown;
            border-left: 1px solid brown;
        }
        .content_one_box{
            height: 100%;
            width: 100%;
            box-sizing: border-box;
            .child_content{
                box-sizing: border-box;
                margin-bottom: 20px;  
                margin-top: 20px;  
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                .item_box:hover{
                    .font_box{
                        border-left: 1px solid #3380FF;
                        border-right: 1px solid #3380FF;
                        border-bottom: 1px solid #3380FF;
                        .html_box{
                            color: #101010;
                        }
                    }
                }
                .item_box{
                    width: 93%;
                    background: #FFFFFF;
                    box-sizing: border-box;
                    position: relative;
                    cursor: pointer;
                    margin-bottom: 40px;
                    .img_box{
                        width:100%;
                        height: 580px;
                        box-sizing: border-box;
                        vertical-align:bottom;
                    }
                    .font_box{
                        width: 100%;
                        min-height: 72%;
                        box-sizing: border-box;
                        border-right: 1px solid  #D5D5D5;
                        border-left: 1px solid  #D5D5D5;
                        border-bottom: 1px solid  #D5D5D5;
                        padding:17px 20px 19px 20px;
                        .html_box{
                            color: #606060;
                            font-size: 35px;
                            line-height: 55px;
                        }
                        .font_title{
                            font-weight: 400;
                            font-size: 40px;
                            color: #101010;
                            line-height: 45px;
                            margin-bottom: 20px;
                            margin-top: 20px;
                        }
                    }
                }
            } 
        }
        .tbs_box{
            height: 100%;
            box-sizing: border-box;
            padding-top: 45px;
            padding-bottom: 20px;
            width: 100%;
            padding-left: 3.5%;
            .tab_item:hover{
                background: #027DFC;
                font-weight: 400;
                font-size: 30px;
                color: #FFFFFF;
                line-height: 70px;
            }
            .cactive{
                background: #027DFC !important;
                color: #FFFFFF !important;
            }
            .tab_item{
                border: 1px solid #ECECEC;
                background: #FFFFFF;
                height: 75px;
                width: 31%;
                text-align: center;
                line-height: 70px;
                box-sizing: border-box;
                cursor: pointer;
                font-weight: 400;
                font-size: 30px;
                color: #606060;
            }
        }
    }

</style>